// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"850f3002","851":"3f0086ba","980":"e8b9e1af"}[chunkId] + ".chunk.js";
};